module.exports = __webpack_public_path__ + "img/lit_twitter.55b5daf8.png";